import { setCountAction, setTypeToggle } from "./_common.js";

const main = () => {
    if (document.querySelector('#page-search-area') === null) return;
    setCountAction();
    // ヒーローの種別トグル（戸建/土地）
    setTypeToggle();
}

export default main;
